import React from 'react';
import { AtbDetails } from 'src/components/AtbModal/AtbModal';
import { PriceSummary } from 'src/components/CustomisationPage/utils/priceEstimates';
import { SummaryInfo } from 'src/components/Basket/SummaryInfo';

import classes from './Summary.scss';
import { SummaryList } from './SummaryList';
import { SummaryTable } from './SummaryTable';

type Props = {
    summary: PriceSummary | null;
    products: AtbDetails[];
    step?: string;
};

export const SummaryStatic: React.FC<Props> = ({ summary, products, step }) => {
    const title = `Customising ${products.length} product${products.length === 1 ? '' : 's'}`;
    return (
        <>
            {' '}
            <div className={classes.summary}>
                <h3 className={classes.summaryTitle}>{title}</h3>
                <SummaryList products={products} />
                {/*<div className={classes.summaryConfig}>*/}
                {/*    <CustomisationSummary image={imagePath(null)} imageAlt="image" method={2} type={true} name="My Logo" />*/}
                {/*</div>*/}
                {summary && step === 'Config' ? (
                    <SummaryTable summary={summary} />
                ) : (
                    <p style={{ marginTop: '20px', marginBottom: '0' }}>
                        Prices will show here once you've completed the customisation
                    </p>
                )}
            </div>
            <SummaryInfo />
        </>
    );
};
